export enum RoomStatus {
    roomBreakColor = 'roomBreakColor',
    roomBusyColor = 'roomBusyColor',
    roomCleanColor = 'roomCleanColor',
    roomFreeColor = 'roomFreeColor',
    roomOverColor = 'roomOverColor',
}
